export const links = [
  // { text: "Services", href: "/services" },
  // { text: "Pricing", href: "/pricing" },
  // { text: "Portfolio", href: "/portfolio" },
  { text: "Contact Us", href: "#contact-us" },
  { text: "How we work", href: "/#how-we-work" },
];
